import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Sparkles } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import logo from "../assets/trimo-logo.png";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = location.hash || window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sid = m ? m[1] : null;
    (async () => {
      if (!sid) {
        navigate("/");
        return;
      }
      let ok = false;
      try {
        const { data } = await api.post("/auth/session", { session_id: sid });
        setUser(data.user);
        ok = true;
      } catch (e) {
        // ignore
      }
      // popup sign-in: tell the main window and close this mini window
      if (window.opener && window.location.pathname === "/auth-popup") {
        try { window.opener.postMessage({ type: "vitled-auth", ok }, window.location.origin); } catch (e) { /* opener gone */ }
        window.close();
        return;
      }
      const back = window.location.pathname;
      window.history.replaceState(null, "", back);
      navigate(back === "/" || back === "/login" ? "/studio" : back);
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background text-zinc-300 gap-4">
      <img src={logo} alt="Vitled" className="h-12 w-12 rounded-xl animate-pulse" />
      <div className="flex items-center gap-2">
        <span className="h-4 w-4 border-2 border-yellow-400/30 border-t-yellow-400 rounded-full animate-spin" />
        <Sparkles className="h-4 w-4 text-yellow-400" />
        <span>Iniciando sesión...</span>
      </div>
    </div>
  );
}
